export default "__VITE_ASSET__CP2q0Lie__"